var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 63.626,
    cy: 64.292,
    r: 62.626,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.977 38.608H47.193c-4.391 0-8.258 3.19-8.258 7.58v33.785c0 4.391 3.867 8.317 8.258 8.317h20.918c-.04-6.511.009-13.763-.022-20.063-1.335-.015-2.671-.084-4.005-.104.006-2.227.002-4.5.004-6.727 1.332-.016 2.668-.02 4.001-.033.04-2.166-.041-4.344.043-6.507.132-1.714.785-3.445 2.065-4.628 1.552-1.476 3.757-1.977 5.835-2.039 2.199-.02 4.398-.01 6.598-.009.009 2.32.009 4.641 0 6.961-1.423-.002-2.845.003-4.266-.003-.901-.055-1.827.627-1.991 1.521-.021 1.553-.008 3.106-.006 4.658 2.084.009 4.169-.002 6.254.006-.152 2.247-.432 4.482-.759 6.709-1.841.018-3.684.183-5.525.194-.015 6.298.005 13.554-.011 20.064h4.65c4.391 0 7.641-3.927 7.641-8.317V46.188c0-4.389-3.25-7.58-7.64-7.58z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.35c19cb7b62b25e3f49ceb6db31a2069.svg";
export { ForwardRef as ReactComponent };